import { useEffect, useRef } from "react";
import { useAuth, api } from "./auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) return;
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res && res.user) {
          setUser(res.user);
          // Migrar cotizaciones de localStorage si existen
          const local = localStorage.getItem("starwest_quotes_v1");
          if (local) {
            try {
              const quotes = JSON.parse(local);
              if (Array.isArray(quotes) && quotes.length > 0) {
                await api.post("/quotes/migrate", { quotes });
                localStorage.removeItem("starwest_quotes_v1");
              }
            } catch {}
          }
        }
      } catch (e) {
        console.error("Auth callback failed:", e);
      }
      // Limpiar hash y redirigir
      window.history.replaceState({}, "", "/");
      window.location.reload();
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <p className="text-slate-500 text-sm">Iniciando sesión…</p>
    </div>
  );
}
